// external
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { NavLink } from "react-router-dom";

// internal
import { customize } from "utils/hoc/Customize";

class CustomButtonUI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnStyles: props.getStyles(`${props.namespace}:button`),
    };
  }

  onLinkOver = (e) => {
    let section = "button";
    if (e.type === "mouseenter") section = "button_hover";

    this.setState({
      btnStyles: this.props.getStyles(`${this.props.namespace}:${section}`),
    });
  };

  getProps = () => {
    const notAllowedProps = ["getStyles", "isRouterLink", "namespace"];

    return Object.keys(this.props)
      .filter((key) => !notAllowedProps.includes(key))
      .reduce((obj, key) => {
        obj[key] = this.props[key];
        return obj;
      }, {});
  };

  getRouterButton = () => {
    const props = this.getProps();

    return (
      <NavLink
        style={this.state.btnStyles}
        onMouseEnter={this.onLinkOver}
        onMouseLeave={this.onLinkOver}
        {...props}
      >
        {this.props.children}
      </NavLink>
    );
  };

  getButton = () => {
    const props = this.getProps();

    return (
      <button
        style={this.state.btnStyles}
        onMouseEnter={this.onLinkOver}
        onMouseLeave={this.onLinkOver}
        {...props}
      >
        {this.props.children}
      </button>
    );
  };

  getDisabledButton = () => {
    const props = this.getProps();
    return (
      <button
        disabled
        style={this.state.btnStyles}
        {...props}
        onClick={() => {}}
      >
        {this.props.children}
      </button>
    );
  };

  render() {
    if (!this.props.disabled) {
      if (this.props.isRouterLink) return this.getRouterButton();
      return this.getButton();
    }
    return this.getDisabledButton();
  }
}

CustomButtonUI.propTypes = {
  children: PropTypes.node.isRequired,
  getStyles: PropTypes.func.isRequired,
  isRouterLink: PropTypes.bool,
  disabled: PropTypes.bool,
  namespace: PropTypes.string.isRequired,
};

export default customize()(CustomButtonUI);
